<script>
    /**
     * 文字提示
     */
    export default {
        name: 'tooltip',
        props: {
            theme: {
                default: 'dark',
                required: false
            },
            content: {
                default: false,
                required: false
            },
            position: {
                default: 'top',
                required: false
            },
            space: {
                default: function() {
                    return {}
                },
                required: false
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            enterable: {
                type: Boolean,
                default: true,
                required: false
            },
            openDelay: {
                type: Number,
                default: 0,
                required: false
            },
            tipWidth: {
                type: Number,
                default: 0,
                required: false
            },
            align: {
                type: String,
                default: 'left',
                required: false
            }
        },
        data () {
            return {
                child: null,
                parent: null,
                showed: false,
                dropX: 0,
                dropY: 0,
                arrowX: 0,
                arrowY: 0,
                hideTimer: null,
                openTimer: null
            };
        },
        methods: {
            setDoms () {
                const $slot = this.$slots.default[0];
                if (!$slot) {
                    return;
                }
                const $el = this.$el;
                const $parent = this.parent = $el.parentNode;
                $parent.insertBefore($slot.elm, $el);
                $el.style.display = 'none';
                document.body.appendChild($el);
                this.child = $slot.elm;
                this.bindEvent();
            },
            removeDoms () {
                this.parent.removeChild(this.child);
            },
            hideTips () {
                this.hideTimer = setTimeout(() => {
                    this.showed = false;
                }, 200);
            },
            showTips () {
                if (this.disabled === true) {
                    return false;
                }
                this.showed = true;
                setTimeout(() => {
                    const rect = this.child.getBoundingClientRect();
                    const optRect = this.$el.getBoundingClientRect();
                    const arrowRect = this.$refs.arrow.getBoundingClientRect();
                    const pageXOffset = window.pageXOffset || window.pageXOffset;
                    const pageYOffset = window.pageYOffset || window.pageYOffset;
                    const stepObj = {
                        left: 7,
                        top: 35
                    };
                    switch (this.position) {
                        case 'bottom':
                            this.dropX = Math.round(rect.left) + (rect.width / 2) - optRect.width / 2;
                            this.dropY = Math.round(rect.top) + stepObj.top;
                            this.arrowX = optRect.width / 2 - arrowRect.width / 2;
                            this.arrowY = -arrowRect.height;
                            break;
                        case 'left':
                            this.dropX = rect.left - optRect.width - stepObj.left;
                            this.dropY = Math.round(rect.top) + (rect.height / 2) - optRect.height / 2;
                            this.arrowX = optRect.width;
                            this.arrowY = optRect.height / 2 - arrowRect.height / 2;
                            break;
                        case 'right':
                            this.dropX = rect.left + rect.width + stepObj.left;
                            this.dropY = Math.round(rect.top) + (rect.height / 2) - optRect.height / 2;
                            this.arrowX = -arrowRect.width;
                            this.arrowY = optRect.height / 2 - arrowRect.height / 2;
                            break;
                        case 'top':
                        default:
                            this.dropX = Math.round(rect.left) + (rect.width / 2) - optRect.width / 2;
                            if(this.space.top) {
                                this.dropY = Math.round(rect.top) - optRect.height - this.space.top;
                            } else {
                                this.dropY = Math.round(rect.top) - (optRect.height / 2) - stepObj.top;
                            }
                            this.arrowX = optRect.width / 2 - arrowRect.width / 2;
                            this.arrowY = optRect.height;
                            break;
                    }
                    this.dropX += pageXOffset;
                    this.dropY += pageYOffset;
                    // this.arrowX += pageXOffset;
                    // this.arrowY += pageYOffset;
                });
            },
            handleMouseLeave () {
                if (this.openTimer) {
                    clearTimeout(this.openTimer);
                }
                this.hideTips();
            },
            handleMouseEnter () {
                if (this.openTimer) {
                    clearTimeout(this.openTimer);
                }
                this.openTimer = setTimeout(() => {
                    this.showTips();
                }, this.openDelay);
            },
            handleTipsMouseLeave () {
                if (!this.enterable) {
                    return;
                }
                this.hideTips();
            },
            handleTipsMouseEnter () {
                clearTimeout(this.hideTimer);
            },
            bindEvent () {
                this.child.addEventListener('mouseenter', this.handleMouseEnter);
                this.child.addEventListener('mouseleave', this.handleMouseLeave);
            },
            offEvent () {
                this.child && this.child.removeEventListener('mouseenter', this.handleMouseEnter);
                this.child && this.child.removeEventListener('mouseleave', this.handleMouseLeave);
                window.removeEventListener('scroll', this.scrollEvent, true);
            },
            bindScrollEvent () {
                this.scrollEvent = () => {
                    this.showed = false;
                };
                window.addEventListener('scroll', this.scrollEvent, true);
            }
        },
        beforeDestroy () {
            this.offEvent();
            this.removeDoms();
            this.$el && document.body.contains(this.$el) && document.body.removeChild(this.$el);
        },
        watch: {},
        computed: {
            curStyle () {
                return {};
            },
            tipStyle () {
                return {
                    left: `${this.dropX}px`,
                    top: `${this.dropY}px`
                };
            },
            arrowStyle () {
                return {
                    left: `${this.arrowX}px`,
                    top: `${this.arrowY}px`
                };
            }
        },
        mounted () {
            this.setDoms();
            this.bindScrollEvent();
        }
    };
</script>

<template>
    <transition name="fade">
        <div class="tooltip__poper"
             @mouseleave="handleTipsMouseLeave($event)"
             @mouseenter="handleTipsMouseEnter($event)"
             v-show="showed"
             :class="[theme, {disabled: disabled}]"
             :style="[tipStyle,{width:  'auto', maxWidth: tipWidth ? `${tipWidth}px`:'auto' ,textAlign: align }]">
            <span v-html="content"></span>
            <slot></slot>
            <div class="popper__arrow"
                 ref="arrow"
                 :class="[position]"
                 :style="arrowStyle"></div>
        </div>
    </transition>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .tooltip__poper {
        position: absolute;
        border-radius: 4px;
        padding: 10px;
        z-index: 12000;
        font-size: 12px;
        line-height: 1.2;
        min-width: 10px;
        transform-origin: center bottom 0;

        &.dark {
            background: @otherNormalTitleClr;
            color: #fff;

            .popper__arrow {
                &.top {
                    border-top-color: @otherNormalTitleClr;
                }

                &.bottom {
                    border-bottom-color: @otherNormalTitleClr
                }

                &.left {
                    border-left-color: @otherNormalTitleClr;
                }

                &.right {
                    border-right-color: @otherNormalTitleClr;
                }
            }
        }

        .popper__arrow {
            width: 0;
            height: 0;
            position: absolute;

            &.top {
                border-top: 7px transparent solid;
                border-right: 4px transparent solid;
                border-left: 4px transparent solid;
            }

            &.bottom {
                border-bottom: 7px transparent solid;
                border-right: 4px transparent solid;
                border-left: 4px transparent solid;
            }

            &.left {
                border-top: 4px transparent solid;
                border-bottom: 4px transparent solid;
                border-left: 7px transparent solid;
            }

            &.right {
                border-top: 4px transparent solid;
                border-bottom: 4px transparent solid;
                border-right: 7px transparent solid;
            }
        }

    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0;
    }
</style>
